import { type ReactElement } from 'react'
import { useSnapshot } from 'valtio'
import {
  ACCESSIBILITY_STATEMENT_URL,
  MARKETING_HOME_PAGE_URL,
  PRIVACY_POLICY_URL,
  STANDARD_PAY_ACCESSIBILITY_STATEMENT_URL,
  STANDARD_PAY_MARKETING_HOME_PAGE,
  STANDARD_PAY_PRIVACY_POLICY_URL
} from '../../../utils/commonUrls'
import { DetermineLogo, DetermineInverseColorIconPoweredBy } from '../../../themes/logoFunctions'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'
import { GlobalSiteDomainEnum } from '../../../types/GlobalSiteDomainEnum'

interface WastePayPoweredByProps {
  expanded: boolean
}

export function WastePayPoweredBy ({ expanded }: WastePayPoweredByProps): ReactElement {
  const { siteDomainEnum } = useSnapshot(proxyGlobalAuth)
  return (
    <>
      {/* Start Collapsed */}
      {!expanded && (
        <a
          href={siteDomainEnum === GlobalSiteDomainEnum.WastePay ? MARKETING_HOME_PAGE_URL : STANDARD_PAY_MARKETING_HOME_PAGE}
          className="w-3/5 h-20 hover:opacity-90 active:opacity-95"
          target="_blank"
          rel="noreferrer noopener"
        >
          <DetermineLogo />
        </a>
      )}
      {/* End Collapsed */}

      {/* Start Expanded */}
      {expanded && (
        <div
          className="w-3/5 text-xs text-wpy-super-light-gray-400 font-light text-center h-20"
        >
          <span className="opacity-80">Powered by</span>
          <a
            href={siteDomainEnum === GlobalSiteDomainEnum.WastePay ? MARKETING_HOME_PAGE_URL : STANDARD_PAY_MARKETING_HOME_PAGE}
            target="_blank"
            rel="noreferrer noopener"
            className="cursor-pointer hover:opacity-90 active:opacity-95"
          >
            <DetermineInverseColorIconPoweredBy />

          </a>
          <a
            href={siteDomainEnum === GlobalSiteDomainEnum.WastePay ? PRIVACY_POLICY_URL : STANDARD_PAY_PRIVACY_POLICY_URL}
            className="block opacity-80 mt-6 cursor-pointer hover:opacity-70 active:opacity-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>

          <a
            href={siteDomainEnum === GlobalSiteDomainEnum.WastePay ? ACCESSIBILITY_STATEMENT_URL : STANDARD_PAY_ACCESSIBILITY_STATEMENT_URL}
            className="block opacity-80 cursor-pointer hover:opacity-70 active:opacity-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Accessibility Statement
          </a>
        </div>
      )}
    </>
  )
}
